App.BusinessContinuityDocumentsTable = class extends App.DataTable {
  constructor(table, noDataText) {
    const dataSourceUrl = "/business_continuity_documents/data_table"

    let columns = [
      {
        sortable: false,
        render: function(data, type, full, meta) {
          return `<a href="${
            full.download_url
          }" target="_blank" class="btn btn-xs btn-muted-blue">
                    <i class="fa fa-download"></i>
                  </a>`
        },
        width: "48px"
      },
      {
        // Select
        sortable: false,
        render: function(data, type, full, meta) {
          return `<input
                    type='checkbox'
                    class='checkbox'
                    data-behavior='bc-file-select'
                    data-base-url='${meta.settings.json.base_url}'
                    data-document-id='${full.id}' />`
        }
      },
      {
        data: "id",
        width: "40px"
      },
      {
        data: "title",
        width: "120px",
        render: function(data, type, full, meta) {
          const editTitleLink = `<a data-behavior="propagate-click-event">
                                  <i class="fa fa-pencil bc-edit-title"
                                     data-document='${JSON.stringify(full)}'>
                                  </i>
                                </a>`
          return `${full.title} ${full.can_edit ? editTitleLink : ""}`
        }
      },
      {
        data: "created_at"
      },
      {
        data: "uploaded_by"
      },
      {
        data: "document_content_type",
        render: (data, type, full) => full.file_type
      },
      {
        data: "document_file_size",
        render: (data, type, full) => full.file_size
      },
      {
        sortable: false,
        render: function ( data, type, full, meta ) {
          if (!full.can_delete) {
            return `<button disabled class="btn btn-xs" style="opacity: 0.4; color: #444;">
                      Delete
                    </button>`;
          }

          return `<a href="/business_continuity_documents/${full.id}/"
                     data-method="delete"
                     data-title="Confirm Document Deletion"
                     data-confirm="Are you sure you want to delete this document (${full.title})?"
                     data-remote="true"
                     data-behavior="propagate-click-event bc_document_delete_link"
                     rel="nofollow"
                     class="btn btn-xs btn-danger">

                    Delete
                  </a>`
        }
      }
    ]

    const noData =
      '<span class="fa fa-info-sign"></span><p>' +
      noDataText +
      "</p>"

    super({
      table: table,
      dataSourceUrl: dataSourceUrl,
      columns: columns,
      noData: noData,
      initialOrder: [[2, "desc"]]
    })

    this.documentBaseUrl = "/business_continuity_documents"
  }

  toggleSelected(selectAll = true) {
    let allCheckboxes = [
      ...document.querySelectorAll("[data-behavior=bc-file-select]")
    ]
    allCheckboxes.forEach(checkbox => (checkbox.checked = selectAll))
  }

  getSelected() {
    let allCheckedCheckboxes = [
      ...document.querySelectorAll("[data-behavior=bc-file-select]:checked")
    ]
    return allCheckedCheckboxes.map(checkbox =>
      checkbox.getAttribute("data-document-id")
    )
  }

  downloadSelected() {
    if (this.getSelected().length > 0) {
      window.open(this.documentBaseUrl + "/" + this.getSelected().join(","))
    }
  }
}

$(document).on("turbo:load", function() {
  if ($(".business_continuity_documents.index").length == 0) return

  var bcDocumentsTable = new App.BusinessContinuityDocumentsTable(
    $("#bc-documents"),
    "No documents have been uploaded."
  )
  bcDocumentsTable.render()

  // Update the total size after table loads
  $(document).on("xhr.dt", "#bc-documents", function(e, settings, json) {
    if(json && json.totalSize) {
      $('#bc-doc-total-size').text(json.totalSize)
    }
  })

  $(document).on("click", "#download-selected", function() {
    bcDocumentsTable.downloadSelected()
  })

  // When the checkbox in the header is clicked, toggle the individual
  // checkboxes accordingly.
  $(document).on(
    "change",
    "[data-behavior=toggle-bc-download-checkboxes]",
    function() {
      bcDocumentsTable.toggleSelected(this.checked)
    }
  )

  // When one of the individual checkboxes is clicked, make sure the
  // checkbox in the header is unchecked
  $(document).on("click", "[data-behavior=bc-file-select]", function() {
    $("[data-behavior=toggle-bc-download-checkboxes]")[0].checked = false
  })
})

$(document).on("business_continuity:uploaded", event => {
  $("[data-behavior=bc_documents_data_table]").each(function() {
    let table = new App.BusinessContinuityDocumentsTable($(this))
    table.reload(true)
  })
})

// Remove deleted items
$(document).on("ajax:success", "[data-behavior~=bc_document_delete_link]", function(data, status, xhr) {
  let link_row = $(this).parents("tr");
  let data_table = $(this).parents("table").DataTable();

  data_table.row(link_row).remove();
  data_table.draw();
});

$(document).on("business_continuity:edited", event => {
  $("[data-behavior=bc_documents_data_table]").each(function() {
    let table = new App.BusinessContinuityDocumentsTable($(this))
    table.reload(false)
  })
})
